import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField } from "material-ui"
import strings from "../../../localization/strings"
import * as utils from "../../../helpers/utils"
interface IProps {
  editIPAddress: string
  hierarchyIPAddresses: string[]
  handleClose(): void
  handleAdd(ipAddress: string): void
  handleUpdate(payload: string): void
}
interface IState {
  ipAddress: string
  errorIPAddress: string
}

export default class AddIPAddressDialog extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      ipAddress: props.editIPAddress ? props.editIPAddress : "",
      errorIPAddress: "",
    }
    autobind(this)
  }

  handleSave() {
    if (!this.checkValidate()) return
    this.props.editIPAddress ? this.props.handleUpdate(this.state.ipAddress.trim()) : this.props.handleAdd(this.state.ipAddress.trim())
  }

  checkValidate() {
    let isValidate = true
    const ipAddress = this.state.ipAddress.trim()
    if (!ipAddress) {
      this.setState({ errorIPAddress: strings.IP_Address_is_required })
      isValidate = false
    }
    else if (!utils.validateIPaddress(ipAddress)) {
      this.setState({ errorIPAddress: strings.IP_Address_is_not_valid })
      isValidate = false
    }
    else if (this.props.hierarchyIPAddresses.filter(item => this.props.editIPAddress ? item !== this.props.editIPAddress : true).find(item => item === ipAddress)) {
      this.setState({ errorIPAddress: strings.IP_Address_is_duplicated })
      isValidate = false
    }
    else {
      this.setState({ errorIPAddress: "" })
    }
    return isValidate
  }

  render() {
    return (
      <Dialog
        open={true}
        title={this.props.editIPAddress ? strings.Edit_IP_Address : strings.New_IP_Address}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        actions={[
          <FlatButton
            data-intercom-target={"IP-Btn-CloseAddIPDialog"}
            label={strings.CANCEL}
            secondary={true}
            onClick={this.props.handleClose}
          />,
          <FlatButton
            data-intercom-target={"IP-Btn-SaveIP"}
            label={strings.SAVE}
            primary={true}
            onClick={this.handleSave}
          />
        ]}
      >
        <hr />
        <div style={{ paddingRight: 20, paddingLeft: 20 }}>
          <div style={{ width: "100%" }}>
            <TextField
              data-intercom-target={"IP-Entry-IPAddress"}
              floatingLabelText={strings.IP_Address}
              value={this.state.ipAddress}
              onChange={(e, value) => { this.setState({ ipAddress: value }, () => this.checkValidate()) }}
              errorText={this.state.errorIPAddress}
              errorStyle={{ position: "absolute", top: 70 }}
            />
          </div>
        </div>
      </Dialog>
    )
  }
}